export default __webpack_public_path__ + "static/media/battery.113750b5.svg";